<template>

    <slick ref="slick" class="slides" :options="slickOptions">

        <slot></slot>

    </slick>

</template>

<script>

import {mapState, mapMutations} from 'vuex';
import Slick from 'vue-slick';
import HeroSlide from "../home/HeroSlide.vue";

export default {
    name: "GroupCarousel",

    components: { Slick },

    props: [ ],

    data() {
        return {
            slickOptions: {
                dots:true,
                autoplay: false,
                autoplaySpeed: 9000,
                arrows:false,
                vertical:false,
                verticalSwiping: false,
                fade: false,
                cssEase: 'linear',
                zIndex:1,
                // lazyLoad:'ondemand',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true,
                            fade: false
                        }
                    }
                ]
            },
        }
    },

    mounted() {

    },

    methods: {

        //close: function () { },

    },

    computed: {

        ...mapState({

            //loc: state => state.loc,

        }),

    },

    watch: {
        //show:function(newValue){ }
    },

    //beforeDestroy: function () { }

}
</script>

<style scoped lang="scss">

</style>
